<template>
    <div class="reconciliation-row" :class="rowClasses" @click="onRowClick">
        <div class="reconciliation-row-main">
            <div class="reconciliation-row-indicator" :class="indicatorClasses">
                <i v-if="isReconciled" class="fa-solid fa-check"></i>
                <i v-else-if="item.selected" class="fa-solid fa-check"></i>
            </div>
            <div class="reconciliation-row-logo" v-if="showLogo">
                <img :src="item.urlLogo" @error="logoError = true" />
            </div>
            <div class="reconciliation-row-content">
                <div class="reconciliation-row-description">{{ item.description }}</div>
                <div class="reconciliation-row-subtext" v-if="item.recipientName">{{ item.recipientName }}</div>
                <div class="reconciliation-row-subtext">{{ item.dueDate }}</div>
                <div class="reconciliation-row-badge" v-if="isReconciled">
                    <Badge title="Conciliado" type="success" size="small" classIcon="fa-solid fa-circle-check" />
                </div>
            </div>
            <div class="reconciliation-row-side">
                <span v-if="canSelect" @click.stop>
                    <Confirmation title="Deseja excluir este lançamento do extrato?" type="danger" :data="item"
                        :confirmed="onDelete">
                        <i class="fa-solid fa-trash reconciliation-row-delete" title="Excluir do extrato"></i>
                    </Confirmation>
                </span>
                <div class="reconciliation-row-value" :class="{ 'reconciliation-row-value-negative': item.value < 0 }">
                    {{ item.value | currency }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import Confirmation from "@/ui/shared/Confirmation.vue";
import Badge from "@/ui/layout/Badge";

export default {
    name: "ReconciliationImportedRow",
    components: { Confirmation, Badge },
    props: {
        item: Object,
    },
    data() {
        return {
            logoError: false,
        };
    },
    computed: {
        showLogo() {
            return !!this.item.urlLogo && !this.logoError;
        },
        isReconciled() {
            return this.item.status == 'conciliado';
        },
        canSelect() {
            return !this.isReconciled;
        },
        rowClasses() {
            return {
                'reconciliation-row-selected': this.item.selected,
                'reconciliation-row-reconciled': this.isReconciled,
                'reconciliation-row-divergent': this.item.status == 'divergente',
                'reconciliation-row-clickable': this.canSelect,
            };
        },
        indicatorClasses() {
            return {
                'reconciliation-row-indicator-done': this.isReconciled,
                'reconciliation-row-indicator-selected': this.canSelect && this.item.selected,
                'reconciliation-row-indicator-empty': this.canSelect && !this.item.selected,
            };
        },
    },
    methods: {
        onRowClick() {
            if (this.canSelect) this.$emit('toggle-select', this.item);
        },
        onDelete() {
            this.$emit('delete', this.item);
        },
    },
};
</script>
<style scoped>
.reconciliation-row {
    border: 1px solid var(--border-color);
    border-radius: 10px;
    padding: 12px 14px;
    background: var(--bg-base);
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    width: 100%;
}

.reconciliation-row-clickable {
    cursor: pointer;
}

.reconciliation-row-selected {
    border-color: var(--color-brand);
    border-width: 2px;
}

.reconciliation-row-reconciled {
    background: var(--bg-elevated);
    border-left: 3px solid var(--color-success);
}

.reconciliation-row-badge {
    margin-top: 6px;
    margin-left: -10px;
}

.reconciliation-row-divergent {
    box-shadow: 0 0 0 1px var(--color-danger);
}

.reconciliation-row-main {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    min-width: 0;
}

.reconciliation-row-indicator {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
}

.reconciliation-row-indicator-done {
    background: var(--color-success);
    color: var(--text-inverse);
}

.reconciliation-row-indicator-selected {
    background: var(--color-brand);
    color: var(--text-inverse);
}

.reconciliation-row-indicator-empty {
    background: var(--bg-base);
    border: 2px solid var(--border-color);
}

.reconciliation-row-logo {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center;
    background: var(--bg-elevated);
    overflow: hidden;
}

.reconciliation-row-logo img {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    object-fit: cover;
}

.reconciliation-row-content {
    flex: 1;
    min-width: 0;
}

.reconciliation-row-description {
    font-size: 14px;
    font-weight: 600;
    color: var(--text-primary);
}

.reconciliation-row-subtext {
    font-size: 12px;
    color: var(--text-secondary);
    margin-top: 2px;
}

.reconciliation-row-side {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
    flex-shrink: 0;
    min-width: 0;
}

.reconciliation-row-value {
    font-weight: 700;
    font-size: 14px;
    color: var(--color-success);
}

.reconciliation-row-delete {
    font-size: 13px;
    color: var(--color-danger);
    cursor: pointer;
}

.reconciliation-row-value-negative {
    color: var(--color-danger);
}
</style>
